import React, { createContext, useContext, useState } from 'react';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Data, DataState } from '../../types/data-providers';
import * as ApiRequests from '../../api/requests';
import { VENDOR_NAME,BLUEPRINT_ORGANIZATION_NAME } from '../../constants';
import { ApiResponse } from '../../api/api-request-helpers';
import { DeviceBlueprintDataOkResponse, GenericNotOkResponse } from '../../api/types';

type BllueprintData = {
    deviceTypeData: Data<any>;
    getDeviceBlueprintData: Function;
    rowKey: string;
};

const Context = createContext<BllueprintData | null>(null);

function useDeviceBlueprint(): BllueprintData {
    const contextState = useContext(Context);
    if (contextState === null) {
        throw new Error('useDeviceBlueprint must be used within a DeviceBlueprintProvider');
    }
    return contextState;
}

const DeviceBlueprintProvider: React.FC = (props) => {
    const authHelper = useAuthHelper();
    const [deviceTypeData, setDeviceTypeData] = useState<Data<any>>({ state: DataState.Loading });
    const [rowKey, setRowKey] = useState('');

    const getDataByAPI = async (
        customerName: string,
        key: string
    ): Promise<ApiResponse<DeviceBlueprintDataOkResponse, GenericNotOkResponse>> => {
        const deviceMasterResult = await ApiRequests.getDeviceBlueprintData(
            {
                vendorName: BLUEPRINT_ORGANIZATION_NAME,
                customerName: VENDOR_NAME,
                key: key,
            },
            { authHelper }
        );
        return deviceMasterResult;
    };
    const getDeviceBlueprintData = async (customerName: string, key: string): Promise<void> => {
        setRowKey(key);
        setDeviceTypeData({
            state: DataState.Loading,
        });
        const deviceBlueprintResult = await getDataByAPI(customerName, key);

        const result = deviceBlueprintResult.ok
            ? setDeviceTypeData({
                  state: DataState.Loaded,
                  value: deviceBlueprintResult.response.data.value,
              })
            : setDeviceTypeData({
                  state: DataState.Error,
                  errorMessage: ApiRequests.extractErrorCodeWithMessage(deviceBlueprintResult.response),
              });
        return result;
    };

    return (
        <Context.Provider
            value={{
                deviceTypeData,
                getDeviceBlueprintData,
                rowKey,
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export { DeviceBlueprintProvider, useDeviceBlueprint };
